<template>
  <b-modal ref="manual-order-model" no-close-on-backdrop id="manual-order-modal" title="Create Manual Order" size="xl"
           @hidden="handleModalHiddenEvent" ok-title="Create Order" @ok="createOrder">
    <div class="accordion my-3" role="tablist">
      <b-card class="m-0" no-body style="overflow: visible">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1
                    class="d-flex align-items-center justify-content-between bg-transparent border-0">
            <span class="d-block" :style="{color: manualOrderFormsValidationInfo.general_info ? '' : 'red'}">
              General Information <span v-if="order_total_price.price">{{order_total_price.price}}{{order_total_price.currency_code}}</span> <br />
              <span v-if="!manualOrderFormsValidationInfo.general_info">Please fill all fields correctly</span>
            </span><span class="accordion-icon"></span>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" visible accordion="manual-order-accordion">
          <b-card-body>
            <b-form>
              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group label="Select Merchant" label-for="merchant-select">
                    <v-select v-model="manual_order_data.merchant" :options="companies" label="company_name" name="merchant"
                              :clearable="false" placeholder="Select Merchant" v-validate="{required: true}"
                              @input="handleMerchantUpdate">
                    </v-select>
                    <div v-if="errors && errors.first('merchant')" class="error_msg">
                      {{ errors.first('merchant') }}
                    </div>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Select Customer" label-for="user-select">
                    <v-select v-model="manual_order_data.customer" :options="customers" label="name" name="customer" v-validate="{required: true}"
                              :clearable="false" placeholder="Select Customer" @input="handleCustomerUpdate">
                    </v-select>
                    <div v-if="errors && errors.first('customer')" class="error_msg">
                      {{ errors.first('customer') }}
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group label="Order Reference" label-for="order-reference">
                    <b-form-input v-model="manual_order_data.customer_reference_no" name="order reference number" type="text"
                                  placeholder="Enter order reference"></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="PO Number" label-for="po-number">
                    <b-form-input v-model="manual_order_data.po_number" id="po-number" type="text"
                                  placeholder="Enter PO number"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group label="PO Document (Optional)" label-for="po-document">
                    <b-form-file accept=".pdf" v-model="manual_order_data.po_document" plain
                                 placeholder="Choose a file or drop it here..."></b-form-file>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="General Comment" label-for="general-comment">
                    <b-form-textarea
                        v-model="manual_order_data.general_comments"
                        id="general-comment"
                        placeholder="Enter any general comments"
                        max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters>
                <b-form-group class="w-50" label="Shipping Address" label-for="shipping-address-select">
                  <v-select name="shipping address" v-model="manual_order_data.shipping_address" :options="customer_addresses" label="address1"
                            :clearable="false" placeholder="Select Address" :disabled="manual_order_data.is_custom_address"
                            v-validate="{required: !manual_order_data.is_custom_address}"
                  >
                  </v-select>
                  <template v-if="!manual_order_data.is_custom_address">
                    <div v-if="errors && errors.first('shipping address')" class="error_msg">
                      {{ errors.first('shipping address') }}
                    </div>
                  </template>
                </b-form-group>
              </b-row>
              <b-form-group label="New Shipping Address">
                <b-form-checkbox id="new-address-checkbox" v-model="manual_order_data.is_custom_address">Enter a new shipping address
                </b-form-checkbox>
                <b-collapse id="new-address-form" v-model="manual_order_data.is_custom_address">
                  <b-card class="mt-3">
                    <b-row no-gutters class="gap-x-2">
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.first_name" name="first name"
                                      class="mb-2" placeholder="First Name"
                                      v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('first name')" class="error_msg">
                          {{ errors.first('first name') }}
                        </div>
                      </b-col>
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.last_name" name="last name"
                                      class="mb-2" placeholder="Last Name" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('last name')" class="error_msg">
                          {{ errors.first('last name') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row no-gutters class="gap-x-2">
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.email" name="email"
                                      class="mb-2" placeholder="Email" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('email name')" class="error_msg">
                          {{ errors.first('email name') }}
                        </div>
                      </b-col>
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.address1" name="address1"
                                      class="mb-2" placeholder="Address" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('address1')" class="error_msg">
                          {{ errors.first('address1') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row no-gutters class="gap-x-2">
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.address2" name="address2"
                                      class="mb-2" placeholder="Second Address"></b-form-input>
                      </b-col>
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.phone_number" name="phone number"
                                      class="mb-2" placeholder="Phone Number" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('phone number')" class="error_msg">
                          {{ errors.first('phone number') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row no-gutters class="gap-x-2">
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.city" name="city"
                                      class="mb-2" placeholder="City" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('city')" class="error_msg">
                          {{ errors.first('city') }}
                        </div>
                      </b-col>
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.zip_code" name="zip code"
                                      class="mb-2" placeholder="Zip Code" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('zip code')" class="error_msg">
                          {{ errors.first('zip code') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row no-gutters class="gap-x-2">
                      <b-col>
                        <b-form-select 
                          v-model="manual_order_data.custom_shipping_address.country" 
                          :options="formattedCountries"
                          name="country"
                          class="mb-2"
                          placeholder="Select Country"
                          v-validate="{ required: manual_order_data.is_custom_address }">
                        </b-form-select>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('country')" class="error_msg">
                          {{ errors.first('country') }}
                        </div>
                      </b-col>
                      <b-col>
                        <b-form-input v-model="manual_order_data.custom_shipping_address.company_name" name="company name"
                                      class="mb-2" placeholder="Company Name" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                        <div v-if="manual_order_data.is_custom_address && errors && errors.first('company name')" class="error_msg">
                          {{ errors.first('company name') }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-form-input v-model="manual_order_data.custom_shipping_address.state" name="state"
                                  class="mb-2 w-50" placeholder="State/Province" v-validate="{required: manual_order_data.is_custom_address}"></b-form-input>
                    <div v-if="manual_order_data.is_custom_address && errors && errors.first('state')" class="error_msg">
                      {{ errors.first('state') }}
                    </div>
                    <b-form-checkbox id="save-new-address-checkbox" v-model="manual_order_data.save_address">Save new shipping address
                    </b-form-checkbox>
                  </b-card>
                </b-collapse>
              </b-form-group>
            </b-form>
          </b-card-body>
        </b-collapse>
      </b-card>
      <template v-if="manual_order_data.merchant">
        <b-card class="m-0" no-body v-for="(factory_product, factory_product_index) in manual_order_data.factory_products"
                :key="factory_product_index" style="overflow: visible">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle="`accordion-product-${factory_product_index}`"
                      class="d-flex align-items-center justify-content-between bg-transparent border-0">
              <span class="d-block" :style="{color: manualOrderFormsValidationInfo.factory_products[factory_product_index] ? '' : 'red'}">
                <span v-if="factory_product_index > 0" @click="removeProduct(factory_product_index)" style="font-size: 12px" class="mr-2 mb-2"><b-icon-dash-square style="color: red;" /></span>
                Product {{ factory_product_index + 1 }}
                <br />
                <span class="font-sm font-weight-lighter" v-if="!manualOrderFormsValidationInfo.factory_products[factory_product_index]">Please fill all fields correctly</span>
              </span>
              <span class="accordion-icon"></span>
            </b-button>
          </b-card-header>
          <b-collapse :id="`accordion-product-${factory_product_index}`" accordion="manual-order-accordion">
            <b-card-body>
              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group>
                    <template #label>
                      Select Product/SKU
                      <span>
                        <b-form-checkbox v-model="factory_product.is_new_product" @change="handleNewProductEnabled($event, factory_product_index)">Custom Product</b-form-checkbox>
                      </span>
                    </template>
                    <template v-if="factory_product.is_new_product">
                      <b-form-input v-model="factory_product.new_product_name" type="text" :name="`product ${factory_product_index + 1} product name`"
                                    placeholder="Custom Product Name"></b-form-input>
                    </template>
                    <template v-else>
                      <v-select v-model="factory_product.product" :options="products" label="sku_id" :name="`product ${factory_product_index + 1} product`"
                                :clearable="false" placeholder="Select Product" @input="handleProductUpdate($event, factory_product_index)">
                      </v-select>
                    </template>
                  </b-form-group>
                </b-col>
                <b-col style="margin-top: 20px">
                    <b-form-group label="Design Nickname" label-for="order-reference">
                      <b-form-input v-model="factory_product.design_nick_name" id="order-reference" type="text"
                                    :name="`product-${factory_product_index}-design-nick-name`"
                                    placeholder="Design Nick Name"></b-form-input>
                    </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters class="gap-x-2">
                <b-col></b-col>
                <b-col>
                    <b-form-group label="Design ID" label-for="design-id">
                      <b-form-input v-model="factory_product.design_id" id="design-id" type="text"
                                    :name="`product-${factory_product_index}-design-id`"
                                    placeholder="Design ID"></b-form-input>
                    </b-form-group>
                </b-col>
              </b-row>

              <b-row no-gutters class="gap-x-2" v-if="!factory_product.is_new_product">
                <b-col>
                  <b-form-group label="Select Style" >
                    <v-select v-model="factory_product.style" :options="styles" label="name" :name="`product ${factory_product_index + 1} style`" :clearable="false" placeholder="Select Style"></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <template v-if="!factory_product.is_new_product">
                    <b-form-group label="Select Addons">
                      <v-select v-model="factory_product.addons" :options="addons" multiple label="title" inputId="addon_id" taggable
                                @input="handleAddonsSelection($event, factory_product_index)" placeholder="Select Addons"></v-select>
                    </b-form-group>
                  </template>
                </b-col>
              </b-row>

              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group label="Design Assets" label-for="po-document">
                    <b-form-checkbox v-if="factory_product_index == 0" class="my-2" v-model="manual_order_data.is_common_assets"
                                     @change="handleProductCommonDataUpdate($event, 'assets')">Use these assets for all products
                    </b-form-checkbox>
                    <template v-if="factory_product_index != 0 && manual_order_data.is_common_assets">
                      <h5>First product assets being used</h5>
                    </template>
                    <template v-else>
                      <b-form-file multiple accept=".png, .svg, .jpg, .jpeg, .pdf, .cdr, .svg, .tif, .tiff, .zip"
                                   :placeholder="`${factory_product.assets.length} assets uploaded`"
                                   :ref="`factory-product-${factory_product_index}-assets-ref`"
                                   @change="handleFileAssets($event, factory_product_index)"></b-form-file>
                      <input type="hidden" :name="`product ${factory_product_index + 1} assets`" v-model="factory_product.assets">
                      <template v-if="factory_product.assets.length > 0">
                        <ul class="pl-2">
                          <li style="list-style: none" v-for="(factory_product_asset_info, factory_product_asset_info_index) in factory_product.assets_info"
                              :key="`factory-product-${factory_product_index}-assets-${factory_product_asset_info_index}`"
                          >
                            <b-icon-dash-square style="color: red; cursor: pointer" class="mr-3 ml-0"
                                                @click="removeFactoryProductAsset(factory_product_index, factory_product_asset_info_index)" />
                            Name: {{ factory_product_asset_info.name }} | Size: {{ (factory_product_asset_info.size / (1024 * 1024)).toFixed(2) }} MB | Extension: {{ factory_product_asset_info.extension }}
                          </li>
                        </ul>
                      </template>
                    </template>
                  </b-form-group>
                </b-col>
                <b-col>
                  <template>
                    <b-form-group label="Upload Roster" label-for="po-document">
                      <template v-if="factory_product_index != 0 && manual_order_data.is_common_rosters">
                        <h5>First product roster being used</h5>
                      </template>
                      <template v-else>
                        <b-form-checkbox v-if="factory_product_index == 0" class="my-2" v-model="manual_order_data.is_common_rosters" @change="handleProductCommonDataUpdate($event, 'roster')">Use this roster for all products
                        </b-form-checkbox>
                        <div class="d-flex">
                          <b-form-file v-model="factory_product.roster_file" accept=".xlsx, .xls" @input="handleRosterFile($event, factory_product_index)"
                                       placeholder="Choose a file or drop it here..."
                                       :disabled="isFileUploadDisabled(factory_product)" :name="`product ${factory_product_index + 1} roster file`" :ref="`factory-product-${factory_product_index}-roster-file-ref`" >
                          </b-form-file>
                          <Download v-if="factory_product.product" class="ml-2 mt-1" @click="downloadTemplate(factory_product.product.id, factory_product.product.sku_id)"
                                     style="cursor: pointer"/>
                        </div>
                        <div v-if="errors && errors.first(`product ${factory_product_index + 1} roster file`)" class="error_msg">
                          {{ errors.first(`product ${factory_product_index + 1} roster file`) }}
                        </div>
                      </template>
                    </b-form-group>
                  </template>
                </b-col>
              </b-row>

              <!--- Front and Back Image upload row start --->
              <b-row no-gutters class="gap-x-2">
                <b-col>
                  <b-form-group label="Upload Front Image" label-for="po-document">
                      <b-form-file accept=".png, .svg, .jpg, .jpeg, .pdf, .cdr, .svg, .tif, .tiff, .zip"
                                   placeholder="Upload Front Image"
                                   :ref="`factory-product-${factory_product_index}-front-image-ref`"
                                   @change="handleFrontBackImage($event, factory_product_index, 'front')"></b-form-file>
                      <input type="hidden" :name="`product ${factory_product_index + 1} front image`" v-model="factory_product.front_image">
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Upload Back Image" label-for="po-document">
                      <b-form-file multiple accept=".png, .svg, .jpg, .jpeg, .pdf, .cdr, .svg, .tif, .tiff, .zip"
                                   placeholder="Upload Back Image"
                                   :ref="`factory-product-${factory_product_index}-back-image-ref`"
                                   @change="handleFrontBackImage($event, factory_product_index,'back')"></b-form-file>
                      <input type="hidden" :name="`product ${factory_product_index + 1} back image`" v-model="factory_product.back_image"  >
                  </b-form-group>
                </b-col>
              </b-row>
              <!--- Front and Back Image upload row ends --->

            </b-card-body>
          </b-collapse>
        </b-card>
        <template v-if="manual_order_data.factory_products.length > 0">
          <b-card class="m-0" no-body style="overflow: visible">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-2 class="d-flex align-items-center justify-content-between bg-transparent border-0">
                Order Summary
                <span class="accordion-icon"></span>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="manual-order-accordion">
              <b-card-body>
                <b-table :items="manual_order_data.factory_products" :fields="headers" hover sorter show-empty>
                  <template #cell(sku)="item">
                    <template v-if="item.item.is_new_product">
                      {{ item.item.new_product_name }}
                    </template>
                    <template v-else-if="item.item.product && item.item.product.sku">
                      {{item.item.product.sku.sku_id}}
                    </template>
                  </template>
                  <template #cell(size)="item">
                    <div class="d-flex gap-1 flex-wrap">
                      <template v-for="(roster, roster_index) in item.item.roster_data">
                        <div :key="`roster_size_${roster_index}`" style="background-color: #cccbcb; color: black; padding: 4px; border-radius: 4px;">
                          <span>{{roster.size}}: {{roster.quantity}}</span>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template #cell(design_name)="item">
                    <template>
                      {{item.item.design_nick_name}}
                    </template>
                  </template>
                  <template #cell(quantity)="item">
                    <template>
                      {{item.item.product_price_object.quantity}}
                    </template>
                  </template>
                  <template #cell(price)="item">
                    <template v-if="!item.item.is_new_product && item.item.product">
                      {{getNetPrice(item.item.product.sku.net_price).toFixed(2)}}
                    </template>
                    <template v-else>
                      0.00
                    </template>
                  </template>
                  <template #cell(amount)="item">
                    <template v-if="!item.item.is_new_product && item.item.product && item.item.product_price_object.quantity">
                      {{ (parseFloat(item.item.product_price_object.quantity) * getNetPrice(item.item.product.sku.net_price)).toFixed(2) }}
                    </template>
                    <template v-else>
                      0.00
                    </template>
                  </template>
                </b-table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </template>
        <b-button class="float-right" @click="addProduct">+ Add Product</b-button>
      </template>
    </div>
  </b-modal>
</template>

<script>
import { http } from "@/config/httpCommon";
import { getDomDocument, handleResponseException, santaClone } from "@/helpers/Helpers";
import readXlsxFile from 'read-excel-file';
import Download from 'vue-material-design-icons/Download.vue';

export default {
  name: "ManualOrder",
  components: {
    Download
  },
  data() {
    return {
      showNewAddressForm: false,
      companies: [],
      customers: [],
      products: [],
      styles: [],
      addons: [],
      customer_addresses: [],
      currentStep: 1,
      manual_order_data: {},
      company_currency: null,
      order_total_price: {},
      headers: [
        {key: 'sku', label: 'SKU'},
        {key: 'design_name', label: 'Design Name'},
        {key: 'size', label: 'Size'},
        {key: 'quantity', label: 'Quantity'},
        {key: 'price', label: 'Price'},
        {key: 'amount', label: 'Amount'}
      ],
      countries: [],
    }
  },
  computed: {
    isMerchant: function() {
      let is_merchant = false
      if(this.auth_user) {
        is_merchant = this.auth_user.role.name === "admin"
      }
      return is_merchant;
    },
    manualOrderFormsValidationInfo() {
      const forms_validation_info = {
        general_info: !(
            this.errors.first('merchant') || this.errors.first('customer') || this.errors.first('order reference number') ||
            this.errors.first('shipping address') ||this.errors.first('address1') || this.errors.first('first name') || this.errors.first('last name')
            || this.errors.first('address1') || this.errors.first('city') || this.errors.first('zip code') || this.errors.first('country')
            || this.errors.first('company name') || this.errors.first('state')
        ),
        factory_products: []
      }
      this.manual_order_data.factory_products.forEach((manual_order_product, manual_order_product_index) => {
        const is_product_section_valid = !(
            this.errors.first(`product ${manual_order_product_index + 1} product`) || this.errors.first(`product ${manual_order_product_index + 1} style`) ||
            this.errors.first(`product ${manual_order_product_index + 1} roster file`) || this.errors.first(`product ${manual_order_product_index + 1} assets`)
        )
        forms_validation_info.factory_products.push(is_product_section_valid)
      })
      return forms_validation_info
    },
    formattedCountries() {
      return [
        { value: null, text: 'Select Country', disabled: true  }, // Default placeholder option
        ...this.countries.map(country => ({
          value: country.id,
          text: country.name
        }))
      ];
    },
  },
  async created() {
    this.manual_order_data = this.getManualOrderDataDefaultObject()
    this.order_total_price = this.getOrderTotalPrice()
    this.countries.length === 0 ? this.getCountries() : []
    await this.getManualOrderData()
  },
  methods: {
    getManualOrderDataDefaultObject(updated_keys={}) {
      const default_object = {
        merchant: null, customer: null, customer_reference_no: null, po_number: null, po_document: null, general_comments: '',
        is_custom_address: false,
        save_address:false,
        custom_shipping_address: {
          first_name: '', last_name: '', email: '', address1: '', address2: '', phone_number: '', city: '', zip_code: '',
          country: null, company_name: '', state: ''
        }, shipping_address: null, is_common_assets: false, is_common_rosters: false,
        factory_products: [{
          factory_id: null, product: null, is_new_product: false, new_product_name: '',style: null, addons: [], design_nick_name: '', design_id: '', assets: [],
          assets_info: [], roster_file: null, roster_data: [], product_price_object: this.getProductPriceDefaultObject(), front_image:'', back_image:'',
        }]
      }
      return {...default_object, ...updated_keys}
    },
    async getManualOrderData(merchant_id=null) {
      let manual_order_data_url = "manual-order-data"
      if(merchant_id) {
        manual_order_data_url += `?company_id=${merchant_id}`
      }
      http.get(manual_order_data_url).then(successResponse => {
        const { companies, company_currency } = successResponse.data.result
        //initialize companies for first time
        if(merchant_id === null) {
          this.companies = companies
        }
        this.company_currency = company_currency
        let selected_merchant = null;
        if(this.companies.length > 0 && (this.isMerchant || merchant_id)) {
          selected_merchant = companies[0]
          this.customers = selected_merchant.customers
          this.products = selected_merchant.products
        }
        this.manual_order_data.merchant = selected_merchant
      }).catch(errorResponse => {
        handleResponseException(errorResponse)
      });
    },
    addProduct() {
      this.manual_order_data.factory_products.push(this.getManualOrderDataDefaultObject().factory_products[0]);
      this.setCommonRosterData()
    },
    setCommonRosterData() {
      const { is_common_rosters } = this.manual_order_data
      const first_product_roster_data = this.manual_order_data.factory_products[0].roster_data
      this.manual_order_data.factory_products.forEach((factory_product, factory_product_index) => {
        if(is_common_rosters) {
          if(factory_product_index > 0) {
            factory_product.roster_data = is_common_rosters ? santaClone(first_product_roster_data) : []
            this.setProductPriceObject(factory_product_index)
          }
        }
      })
    },
    async handleMerchantUpdate(selected_merchant) {
      await this.getManualOrderData(selected_merchant.id)
      this.manual_order_data.customer = null
      this.manual_order_data.shipping_address = null
      this.customer_addresses = []
      this.manual_order_data.factory_products.forEach((factory_product, factory_product_index) => {
       // factory_product.product = null
        this.handleProductUpdate(null, factory_product_index)
      })
    },
    handleCustomerUpdate(selected_customer) {
      this.manual_order_data.shipping_address = null
      this.customer_addresses =  selected_customer.addresses
      this.manual_order_data.custom_shipping_address.first_name = selected_customer.first_name
      this.manual_order_data.custom_shipping_address.last_name = selected_customer.last_name
      this.manual_order_data.custom_shipping_address.email = selected_customer.email
      this.manual_order_data.custom_shipping_address.phone_number = selected_customer.phone_number
      this.manual_order_data.custom_shipping_address.company_name = selected_customer.company_name ? selected_customer.company_name : selected_customer.company_name
    },
    handleProductUpdate(selected_product, factory_product_index) {
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      factory_product.style = null
      factory_product.addons = []
      this.resetRosterData(factory_product_index)
      if(selected_product) {
        this.styles = selected_product.productstyles
        this.addons = selected_product.active_addons
      } else {
        factory_product.product = null
        this.styles = []
        this.addons = []
      }
      this.setProductPriceObject(factory_product_index)
    },
    async downloadTemplate(product_id, product_name) {
      await http.get(`template/download/${product_id}`, {
        responseType: 'blob',
      }).then((res) => {
        const blob = new Blob([res.data], {type: res.headers['content-type']})
        const custom_document = getDomDocument(true);
        const link = custom_document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'product_' + product_name + '_template.xlsx';
        link.click();
      })
    },
    async handleRosterFile($event, factory_product_index){
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      if($event) {
        const factory_product_selected_product = factory_product.product
        const files = $event;
        const ext = files.name.split('.').pop();
        const updated_roster = []
        if (ext != 'xlsx'){
          alert("The Excel file that was uploaded cannot be read, or it does not adhere to the template format. Please download the Excel template located next to the upload field, input your data there, and then attempt the upload again.");
          this.resetRosterData(factory_product_index)
          this.showLoader = false;
          return false
        }
        let check_cols = false;
        let check_design_cols = false;

        readXlsxFile(files).then((rows) => {
          check_cols = rows[0][0] == 'NAME ON PRODUCT' && rows[0][1] == 'NUMBER' && rows[0][2] == 'SIZE*' && rows[0][3] == 'QUANTITY*'
          check_design_cols = rows[0][4] == 'DESIGN NAME (Optional)' && rows[0][5] == 'DESIGN ID (Optional)'

          if (rows[0].length != 4 && rows[0].length != 6){
            alert("The Excel file that was uploaded cannot be read, or it does not adhere to the template format. Please download the Excel template located next to the upload field, input your data there, and then attempt the upload again.");
            this.resetRosterData(factory_product_index)
            this.showLoader = false;
            return false
          }else if(rows.length < 2){
            this.resetRosterData(factory_product_index)
            alert("The excel file has no data in it");
            this.showLoader = false;
            return false
          }else if(check_cols && !check_design_cols){
            rows.forEach((row, index)=>{
              if(index){
                const typeof_number = typeof row[1];
                if(typeof_number === "number") {
                  row[1] = row[1].toString();
                }
                //object type means the value is null
                if(typeof_number === "object") {
                  row[1] = '';
                }
                if(row[1].constructor.name == "Number") {
                  row[1] = row[1].toString()
                }
                const roster = {
                  "text": row[0],
                  "number": row[1],
                  "size": row[2],
                  "quantity": row[3],
                  "information": ""
                }
                updated_roster.push(roster)
              }
            })
            factory_product.roster_data = updated_roster
            this.setCommonRosterData()
            this.setProductPriceObject(factory_product_index)
          }else if(check_cols && check_design_cols){
            readXlsxFile(files).then((rows) => {
              if(check_design_cols){
                const nameIndex = 0;
                const playerNumberIndex = 1;
                const sizeIndex = 2;
                const quantityIndex = 3;
                const designNameIndex = 4;
                const designIdIndex = 5;

                let productMap = new Map();
                // Process the rows, ensuring uniqueness on product name, design name, and design ID
                rows.slice(1).forEach(row => {
                    let nameOnProduct = (row[nameIndex] && typeof row[nameIndex] === "string")  ? row[nameIndex].trim() : String(row[nameIndex] || "");
                    let playerNumber = (row[playerNumberIndex] && typeof row[playerNumberIndex] === "string")  ? row[playerNumberIndex].trim() : String(row[playerNumberIndex] || "");
                    let size = (row[sizeIndex] && typeof row[sizeIndex] === "string")  ? row[sizeIndex].trim() : String(row[sizeIndex] || "");
                    let quantity = row[quantityIndex];
                    let designName = (row[designNameIndex] && typeof row[designNameIndex] === "string")  ? row[designNameIndex].trim() : String(row[designNameIndex] || "");
                    let designId = (row[designIdIndex] && typeof row[designIdIndex] === "string") ? row[designIdIndex].trim() : String(row[designIdIndex] || ""); 

                    const typeof_number = typeof playerNumber;
                      if(typeof_number === "number") {
                        playerNumber = playerNumber.toString();
                      }
                      //object type means the value is null
                      if(typeof_number === "object") {
                        playerNumber = '';
                      }
                      if(playerNumber.constructor.name == "Number") {
                        playerNumber = playerNumber.toString()
                      }

                      let roster = {
                        "text":nameOnProduct,
                        "number": playerNumber,
                        "size": size,
                        "quantity": quantity,
                        "information": ""
                      };

                      if(designName === "" || designId === ""){
                        designName = "";
                        designId = "";
                      }
                      let key = `${designName}|${designId}`;

                      // If key doesn't exist, initialize it
                      if (!productMap.has(key)) {
                          productMap.set(key, {
                              nameOnProduct,
                              designName,
                              designId,
                              details: [] // Store playerNumber, size, quantity inside an array
                          });
                      }

                      // Add player number, size, and quantity to the respective product entry
                      productMap.get(key).details.push(roster);
                });

                let loop_index = 0;
                // Add unique products to `manual_order_data.factory_products`
                productMap.forEach(({ nameOnProduct, designName, designId, details }) => {
                    let current_factory_product = { ...this.manual_order_data.factory_products[factory_product_index] };

                    let factory_product = {
                        ...current_factory_product,
                        product_name: nameOnProduct,
                        design_nick_name: designName,
                        design_id: designId,
                        roster_data: details, // Include playerNumber, size, quantity
                    };

                    if (loop_index == 0 && current_factory_product.design_nick_name == "" && current_factory_product.design_id == "") {
                      // Replace the first item
                      this.manual_order_data.factory_products[factory_product_index] = factory_product;
                    } else {
                      // Otherwise, push a new product
                      factory_product.front_image = "";
                      factory_product.back_image = "";
                      factory_product.assets = [];
                      this.manual_order_data.factory_products.push(factory_product);
                    }

                    this.manual_order_data.factory_products.forEach((_,index) => {
                      this.setCommonRosterData()
                      this.setProductPriceObject(index)
                    });

                    loop_index++;
                });
              }
            })
          }
          else{
            this.resetRosterData(factory_product_index)
            this.showLoader = false;
          }
          this.showToast('Excel file uploaded successfully', 'SUCCESS');
        })
      } else {
       this.resetRosterData(factory_product_index)
      }
    },
    resetRosterData(factory_product_index) {
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      factory_product.roster_data = []
      factory_product.roster_file = null
      if(this.$refs[`factory-product-${factory_product_index}-roster-file-ref`] && this.$refs[`factory-product-${factory_product_index}-roster-file-ref`][0]) {
        this.$refs[`factory-product-${factory_product_index}-roster-file-ref`][0].reset()
      }
      this.setCommonRosterData()
      this.setProductPriceObject(factory_product_index)
    },
    createOrder(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.$validator.validate().then(async (validated) => {
        if(validated) {
          const manual_order_payload_data = await this.getManualOrderPayload()
          this.$store.commit('set', ['showLoader', true]);
          http.post('create-manual-order', manual_order_payload_data).then(successResponse => {
            this.showToast('Order created successfully', 'SUCCESS');
            this.$store.commit('set', ['showLoader', false]);
            this.$refs['manual-order-model'].hide()
            this.$emit('order-created', true)
          }).catch(errorResponse => {
            this.$store.commit('set', ['showLoader', false]);
            handleResponseException(errorResponse)
          })
        } else {
          this.showToast('Manual Order data not validated', 'error');
          this.$store.commit('set', ['showLoader', false]);
        }
      });

    },
    handleModalHiddenEvent() {
      this.manual_order_data = this.getManualOrderDataDefaultObject()
    },
    handleFileAssets(event, factory_product_index) {
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      const factory_product_assets_input = this.$refs[`factory-product-${factory_product_index}-assets-ref`][0]
      if(event.target.files.length > 0) {
        const factory_product_assets = Array.from(event.target.files)
        factory_product_assets_input.reset()
        factory_product.assets = [...factory_product.assets, ...factory_product_assets]
        factory_product.assets_info = factory_product.assets.map(factory_product_asset => ({
          file: factory_product_asset,
          name: factory_product_asset.name,
          size: factory_product_asset.size,
          extension: factory_product_asset.name.split('.').pop().toLowerCase()
        }))
      }
      this.validateFactoryProductAssets(factory_product_index)
      // else {
      //   this.manual_order_data.factory_products[factory_product_index].assets_info = []
      // }
    },
    handleFrontBackImage(event, factory_product_index,side) {
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      if(event.target.files.length > 0) {
        const factory_product_image = Array.from(event.target.files)
        factory_product[`${side}_image`] = factory_product_image[0]
      }
    },
    removeFactoryProductAsset(factory_product_index, asset_index) {
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      if(asset_index >= 0) {
        factory_product.assets_info.splice(asset_index, 1)
        factory_product.assets.splice(asset_index, 1)
      } else {
        factory_product.assets = []
        factory_product.assets_info = []
        if(this.$refs[`factory-product-${factory_product_index}-assets-ref`] && this.$refs[`factory-product-${factory_product_index}-assets-ref`][0]) {
          this.$refs[`factory-product-${factory_product_index}-assets-ref`][0].reset()
        }
      }
      this.validateFactoryProductAssets(factory_product_index)
    },
    async getManualOrderPayload(return_object = false) {
      const manual_order_data = this.manual_order_data
      const shipping_address_info_obj = this.getShippingAddressInfoObject()
      let manual_order_payload = {
        company_id: manual_order_data.merchant.id, company_name: manual_order_data.merchant.company_name,
        customer_id: manual_order_data.customer.id, customer_name: manual_order_data.customer.name, design_file: '',
        po_number: manual_order_data.po_number, po_document: manual_order_data.po_document, general_comments: manual_order_data.general_comments,
        customer_reference_no: manual_order_data.customer_reference_no, address_id: shipping_address_info_obj.address_id, save_address: manual_order_data.save_address,
        shipping_address: shipping_address_info_obj.shipping_address, factory_products: []
      }
      manual_order_data.factory_products.forEach((factory_product, factory_product_index) => {
        const {is_new_product, new_product_name, design_nick_name,design_id, product: selected_product, style: selected_style, roster_data} = factory_product
        let factory_id = null, factory_name = null, product_id = null, sku_number = '', product_name = '', product_type = '', measurement_ratio = 0, sizechart_reference = '',
            minimum_order_quantity = '', minimum_order_quantity_type = '', style_id = -1, style_name = ''
        if(!is_new_product) {
          factory_id = selected_product?.factory_id
          factory_name = selected_product?.factory ? selected_product.factory.name : null
          product_id = selected_product?.id
          sku_number =  selected_product?.sku.sku_number
          product_name = selected_product?.sku.sku_id
          product_type = selected_product?.product_type
          sizechart_reference = selected_product?.sku.sizechart_reference
          measurement_ratio = selected_product?.measurement_ratio
          minimum_order_quantity = selected_product?.sku.minimum_order_quantity
          minimum_order_quantity_type = selected_product?.sku.minimum_order_quantity_type
        }
        if(selected_style) {
          style_name = selected_style?.name
          style_id = selected_style?.id
        }
        let addons = this.getValidAddons(factory_product.addons);
        const factory_product_data = {
          //id will be set on backend
          id: "", factory_id, factory_name, addons: addons, assets: factory_product.assets.map(factory_product_asset => factory_product_asset),
          svg_url: "", sync_id: null, style_id, style_name, design_id: design_id, design_nick_name, svg_parts: [], back_image: factory_product.back_image, front_image: factory_product.front_image,
          is_new_product, new_product_name, product_id, sku_number, product_name, product_type, sort_order: factory_product_index + 1,
          reorder_data: null, grouped_addons: [], production_url: "", back_image_short: "",
          fixed_logo_index: 0, ungrouped_addons: [], front_image_short: "", is_custom_product: is_new_product,
          custom_product_placeholder: 'placeholders/custom-design.png', measurement_ratio,
          sizechart_reference, product_price_object: factory_product.product_price_object, shuffle_color_number: 1,
          product_roster_detail: roster_data, size_variants_mapping: null,
          minimum_order_quantity, minimum_order_quantity_type,
          product_custom_text_objects: {common: [], roster: []},
        }
        manual_order_payload.factory_products.push(factory_product_data)
      })
      if(return_object) {
        return manual_order_payload
      } else {
        const form_data_stringify_types = ['Object', 'Array', 'Number', 'Boolean']
        let manual_order_form_data_payload = new FormData();
        manual_order_payload.factory_product
        for (const [manual_order_payload_key, manual_order_payload_value] of Object.entries(manual_order_payload)) {
          const need_to_stringify_value = manual_order_payload_value && form_data_stringify_types.includes(manual_order_payload_value.constructor.name)
          if(need_to_stringify_value) {
            if(manual_order_payload_key === "factory_products" ) {
              manual_order_payload_value.forEach((factory_product, factory_product_index) => {
                for(const [factory_product_key, factory_product_value] of Object.entries(factory_product)) {
                  //keys that no need to append to payload
                  if(factory_product_key !== "assets_info") {
                    if(factory_product_key === "assets") {
                      if(factory_product_value.length > 0 ) {
                        factory_product_value.forEach((factory_product_asset, ) => {
                          manual_order_form_data_payload.append(`factory_products[${factory_product_index}][assets][]`, factory_product_asset)
                        })
                      } else {
                        manual_order_form_data_payload.append(`factory_products[${factory_product_index}][assets][]`, JSON.stringify([]))
                      }
                    } else {
                      const stringify_factory_product_key = factory_product_value && form_data_stringify_types.includes(factory_product_value.constructor.name)
                      const factory_product_key_value_processed = stringify_factory_product_key ?  JSON.stringify(factory_product_value) : factory_product_value
                      manual_order_form_data_payload.append(`factory_products[${factory_product_index}][${factory_product_key}]`, factory_product_key_value_processed)
                    }
                  }
                }
              })
            } else {
              manual_order_form_data_payload.append(`${manual_order_payload_key}`, JSON.stringify(manual_order_payload_value))
            }
          } else {
            manual_order_form_data_payload.append(`${manual_order_payload_key}`, manual_order_payload_value)
          }
        }
        return manual_order_form_data_payload
      }
    },
    getProductPriceDefaultObject() {
      const product_price_default_object = { currency_code: null, currency_symbol: null, product_price: 0, quantity: 0}
      if(this.company_currency) {
        product_price_default_object.currency_code = this.company_currency.code
        product_price_default_object.currency_symbol = this.company_currency.symbol
      }
      return product_price_default_object
    },
    setProductPriceObject(factory_product_index) {
     let product_price_object = this.getProductPriceDefaultObject()
      const factory_product = this.manual_order_data.factory_products[factory_product_index]
      if(!factory_product.is_new_product) {
        if(factory_product.product && factory_product.product.sku.sku_currency) {
          product_price_object.product_price = factory_product.product.sku.sku_currency.price
        }
      }
      factory_product.roster_data.forEach(roster_data_item => {
        const roster_item_quantity = product_price_object.quantity +  (roster_data_item.quantity ? parseInt(roster_data_item.quantity) : 0)
        product_price_object.quantity = roster_item_quantity
      })
      factory_product.product_price_object = product_price_object
      this.order_total_price = this.getOrderTotalPrice()
    },
    handleProductCommonDataUpdate(is_common, type) {
      if(is_common) {
        this.manual_order_data.factory_products.forEach((factory_product, factory_product_index) => {
          if(factory_product_index > 0) {
            if(type === "assets") {
              this.removeFactoryProductAsset(factory_product_index)
            } else {
              this.resetRosterData(factory_product_index)
            }
          }
        })
      } else {
        if(type === "roster") {
          this.setCommonRosterData()
        }
      }
    },
    getShippingAddressInfoObject() {
      const manual_order_data = this.manual_order_data
      let address_id = null
      let shipping_address = manual_order_data.custom_shipping_address
      if(!manual_order_data.is_custom_address) {
        address_id = manual_order_data.shipping_address.id
        const {
          first_name, last_name, email, address1, address2, phone_number, city, zip_code, country, company_name, state
        } = manual_order_data.shipping_address
        shipping_address = {
          first_name, last_name, email, address1, address2, phone_number, city, zip_code, country, company_name,
          state
        }
      }
      return { address_id, shipping_address }
    },
    getOrderTotalPrice() {
      let order_price = {
        currency_code: '', currency_symbol: '', price: 0
      }
      this.manual_order_data.factory_products.forEach((factory_product, factory_product_index) => {
        //if new product then it will not have price, addons, styles
        if(!factory_product.is_new_product) {
          let { addons, product_price_object, product } = factory_product
          let sku = null
          if(product) {
            sku = product.sku
          }
          let product_net_price = null
          if(sku && sku.net_price) {
            product_net_price = this.getNetPrice(sku.net_price)
            if(!order_price.currency_code) {
              order_price.currency_code = sku.net_price.code
              order_price.currency_symbol = sku.net_price.symbol
            }
            if(product_net_price) {
              if(product_price_object.quantity) {
                order_price.price = parseFloat(order_price.price) + ( product_net_price * parseInt(product_price_object.quantity ))
              }
            }
          }
          addons.forEach(addon => {
            if(addon.net_price) {
              const addon_net_price = this.getNetPrice(addon.net_price)
              if(addon_net_price && product_price_object.quantity) {
                order_price.price = order_price.price + (addon_net_price * parseInt(product_price_object.quantity))
              }
            }
          })
        }
      })
      if(order_price.price) {
        order_price.price = parseFloat(order_price.price).toFixed(2)
      }
      return order_price
    },
    removeProduct(factory_product_index) {
      this.manual_order_data.factory_products.splice(factory_product_index, 1);
      this.order_total_price = this.getOrderTotalPrice()
    },
    handleNewProductEnabled(is_new_product, factory_product_index) {
      if(is_new_product) {
        this.resetRosterData(factory_product_index)
        const factory_product = this.manual_order_data.factory_products[factory_product_index]
        factory_product.product = null
        factory_product.style = null
        factory_product.addons = []
        this.setProductPriceObject(factory_product_index)
      }
    },
    getNetPrice(net_price_obj) {
      //first check is_fixed if its true then used fixed. if not then check discounted price if it is then set discounted price else use net price
      let sku_net_price = null
      if(net_price_obj) {
        const {is_fixed, fixed_price, discounted_price, net_price } = net_price_obj;
        if(is_fixed) {
          sku_net_price = fixed_price
        } else if(discounted_price) {
          sku_net_price = discounted_price
        } else {
          sku_net_price = net_price
        }
      }
      sku_net_price = parseFloat(sku_net_price)
      return isNaN(sku_net_price) ? 0 : sku_net_price;
    },
    handleAddonsSelection(selected_addons, factory_product_index) {
      this.setProductPriceObject(factory_product_index)
    },
    async validateFactoryProductAssets(factory_product_index) {
      setTimeout(() => {
        this.$validator.validate(`product ${factory_product_index + 1} assets`)
      })
    },
    getCountries() {
        http.get(`/addresses/countries`).then((response) => {
          this.countries = response.data.result
        })
        .catch((e) => {
          this.showToast('Error in fetching countries', 'Error')
        });
    },
    getValidAddons(selected_addons){
      // console.log("selected addons",selected_addons);

      const validAddons = selected_addons.map((addon) => {
        if (addon && typeof addon === 'object' && 'title' in addon) {
          return addon; // Keep valid addons as-is
        } else if (typeof addon === 'string') {
          return { title: addon }; // Convert string to object with title key
        }
      }); // Remove null/invalid addons
// console.log("addons",validAddons);
      return validAddons;
    },
    isFileUploadDisabled(factory_product){
      if(factory_product.is_new_product){
        return false;
      }else{
        return factory_product.product == null;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.accordion {
  .card-header {
    background: none;
    border: none;
  }

  .card {
    border-radius: 0;
  }

  .btn:not(.isBtn) {
    background: none;
    border: none;
    color: #03142E;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    &:focus {
      box-shadow: none;
    }

    &:active {
      background: none;
      border: none;
      color: #03142E;
    }

    .accordion-icon {
      background: #808895;
      width: 18px;
      height: 18px;
      border-radius: 2px;
      display: block;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        left: 50%;
        top: 50%;
        border: 6px solid transparent;
        border-top: 6px solid #fff;
        margin: -2px 0 0 -6px;
      }
    }

    &.not-collapsed {
      .accordion-icon {
        transform: rotate(180deg);
        background: #2819ae;

        &:before {
          margin-top: -3px;
        }
      }
    }

    .text {
      width: 100%;
    }
  }

  .nav-link {
    font-size: 12px;
    padding: 0.5rem;
    color: #03142E;
    font-weight: 600;
    border-bottom: 1px solid #EFF2F4;
    transition: all 0.3s ease;

    &:hover {
      border-bottom: 1px solid #219F84;
    }
  }
}
</style>